/**
 * Logout bounce page (federated mode).
 *
 * Cognito redirects here after clearing its own session. Clearing Cognito does not end the upstream
 * IDP session, so this page forwards the browser to the IDP's end-session endpoint (RP-initiated
 * logout); the IDP then returns the user to the login page. If the IDP advertises no end-session
 * endpoint (or discovery fails), we fall back to /login directly - the local and Cognito sessions
 * are already cleared.
 */

import Box from "@cloudscape-design/components/box"
import SpaceBetween from "@cloudscape-design/components/space-between"
import Spinner from "@cloudscape-design/components/spinner"
import { useEffect } from "react"
import { getIdpLogoutUrl } from "../../services/federatedLogout"
import { ROUTES } from "../../utils/constants"

const AuthLogout = () => {
  useEffect(() => {
    void (async () => {
      const idpLogoutUrl = await getIdpLogoutUrl()
      // Full-page navigation: to the IDP's end-session endpoint (which then returns to /login), or
      // straight to /login when discovery is unavailable.
      window.location.replace(idpLogoutUrl ?? ROUTES.LOGIN)
    })()
  }, [])

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Box textAlign="center">
        <SpaceBetween size="l" direction="vertical" alignItems="center">
          <Spinner size="large" />
          <Box variant="p">Signing you out...</Box>
        </SpaceBetween>
      </Box>
    </div>
  )
}

export default AuthLogout
